import { call, put, select } from 'redux-saga/effects';
import { sendRequest } from 'api';
import { AppState } from 'store';
import {
  receivedChannelMessages,
  receivedChannelMessagesError,
} from './actions';

// selector to get the current channel id
export const getCurrentChannelId = (state: AppState) => state.currentChannel.id;
export const getCurrentTeammates = (state: AppState) => state.teammates.list;

function* getAllChannelMessages() {
  try {
    // @ts-ignore
    const currentChannelId = yield select(getCurrentChannelId);
    // @ts-ignore
    const currentTeammates = yield select(getCurrentTeammates);
    const {
      data: { messages },
      // @ts-ignore
    } = yield call(sendRequest, {
      method: 'GET',
      url: `/messages?channelId=${currentChannelId}`,
    });

    for (let i = 0; i < messages.length; i += 1) {
      for (let j = 0; j < currentTeammates.length; j += 1) {
        if (messages[i].user.username === currentTeammates[j].username) {
          messages[i].user.color = currentTeammates[j].color;
        }
      }
    }

    // dispatch action
    yield put(receivedChannelMessages(messages));
  } catch (e) {
    // eslint-disable-next-line
    // console.log('getChannelMessages saga error: ', e);
    // dispatch an error
    yield put(receivedChannelMessagesError((e as any).message));
  }
}

export default getAllChannelMessages;
